import { MonotoneSvgProps } from './types';

export default function ScatterBetadivSVG({ primaryColor }: MonotoneSvgProps) {
  return (
    // <!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      xmlSpace="preserve"
    >
      <style type="text/css">
        {/* <!-- svg classes --> */}
        .dots&#123;fill-rule:evenodd;clip-rule:evenodd;stroke:#FFFFFF;stroke-width:4.0441;stroke-miterlimit:10;&#125;
      </style>
      <g style={{ fill: primaryColor }} className="primary-fill">
        <circle id="Dot_1" className="dots" cx="85" cy="187.31" r="16.53" />
        <circle id="Dot_2" className="dots" cx="66.53" cy="248.9" r="16.53" />
        <circle
          id="Dot_2-2"
          className="dots"
          cx="316.22"
          cy="433.07"
          r="16.53"
        />
        <circle
          id="Dot_2-3"
          className="dots"
          cx="278.05"
          cy="395.12"
          r="16.53"
        />
        <circle
          id="Dot_2-4"
          className="dots"
          cx="213.58"
          cy="389.01"
          r="16.53"
        />
        <circle
          id="Dot_2-5"
          className="dots"
          cx="119.9"
          cy="244.96"
          r="16.53"
        />
        <circle id="Dot_3" className="dots" cx="277.16" cy="121.15" r="16.53" />
        <circle id="Dot_4" className="dots" cx="316.22" cy="71.47" r="16.53" />
        <circle id="Dot_5" className="dots" cx="347.05" cy="157.19" r="16.53" />
        <circle id="Dot_5-2" className="dots" cx="238.2" cy="89.26" r="16.53" />
        <circle id="Dot_6" className="dots" cx="402.67" cy="140.66" r="16.53" />
        <circle
          id="Dot_6-2"
          className="dots"
          cx="101.53"
          cy="288.08"
          r="16.53"
        />
        <circle id="Dot_6-3" className="dots" cx="390.4" cy="66.93" r="16.53" />
        <circle id="Dot_7" className="dots" cx="391.59" cy="376.42" r="16.53" />
        <circle
          id="Dot_7-2"
          className="dots"
          cx="361.68"
          cy="110.19"
          r="16.53"
        />
        <circle
          id="Dot_7-3"
          className="dots"
          cx="433.47"
          cy="303.34"
          r="16.53"
        />
        <circle id="Dot_8" className="dots" cx="145.32" cy="195.33" r="16.53" />
        <circle
          id="Dot_8-2"
          className="dots"
          cx="334.82"
          cy="373.57"
          r="16.53"
        />
      </g>
    </svg>
  );
}
